import React from 'react';
import logo from './logo.svg';
import './App.css';
import { BrowserRouter } from 'react-router-dom';
import Router from './router';
import QueryProvider from './provider/queryProvider';

function App() {
  return (
    <QueryProvider>
      <BrowserRouter>
        <div className='App'>
          <Router />
        </div>
      </BrowserRouter>
    </QueryProvider>
  );
}

export default App;
